import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import EmailInput from "../components/form/EmailInput.jsx";
import PasswordInput from "../components/form/PasswordInput.jsx";
import login from "../controllers/auth/login.js";
import Button1 from "../components/form/Button1.jsx";
import Logo from "../components/icon/Logo.jsx";
import { setUser } from "../reducers/userReducer.js";

export default function LoginPage() {
  const { user } = useSelector((state) => state.user);
  const [data, setData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function handleSubmit(ev) {
    ev.preventDefault();

    setLoading(true);
    let res = {
      return: 0,
      msg: "Something went wrong on our end! Please contact support. 0xSTLOG",
    };
    res = await login(data).then((res) => {
      dispatch(setUser(res?.data));
    });
    setLoading(false);
  }

  return (
    <div className="flex flex-col min-h-screen font-bold gap-4 items-center justify-center ">
      {/* <div className="w-full p-3 px-5 flex gap-2 bg-secondary justify-center sm:justify-start">
        <Logo />
      </div> */}
      <form
        onSubmit={handleSubmit}
        className="w-full flex flex-col items-center justify-center flex-1 bg-white "
      >
        <div className="card flex flex-col gap-5 text-center !pt-12">
          <h4 className="pb-6 text-3xl">Sign in to your account</h4>
          <EmailInput
            required
            className="!w-full sm:!w-[400px] max-w-full"
            value={data.email}
            placeholder=""
            onChange={(ev) => setData({ ...data, email: ev.target.value })}
          />
          <PasswordInput
            required
            noValidation
            placeholder=""
            className="!w-full sm:!w-[400px] max-w-full"
            value={data.password}
            onChange={(ev) => setData({ ...data, password: ev.target.value })}
          />
          <Button1 loading={loading} type="submit" label={"Login"}></Button1>
        </div>
      </form>
    </div>
  );
}
